import { render, staticRenderFns } from "./SettingsQuickReplies.vue?vue&type=template&id=718e2ff1&scoped=true"
import script from "./SettingsQuickReplies.vue?vue&type=script&lang=js"
export * from "./SettingsQuickReplies.vue?vue&type=script&lang=js"
import style0 from "./SettingsQuickReplies.vue?vue&type=style&index=0&id=718e2ff1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "718e2ff1",
  null
  
)

export default component.exports